import type { StudyPlanType } from '../enums/study-plan-type.enum';
import type { AssignedStudyPlan, StudyPlan } from './study-plan';

export enum VisibleModalStudyPlans {
  CHANGE_STUDY_PLAN = 'CHANGE_STUDY_PLAN',
  CHANGE_STUDY_PLAN_SUCCESS = 'CHANGE_STUDY_PLAN_SUCCESS',
}

export interface StudyPlansProps {
  studyPlansData: StudyPlan[];
  studyPlansDataLoading: boolean;
  error?: string;
  isSuccess: boolean;
  isLoading: boolean;
  onSubmit: (studyPlan: StudyPlanType, contactId: string) => void;
  assignedStudyPlan?: AssignedStudyPlan;
}
